import { ClaudeTemplate } from "../types";

/** Taboola (NATADS con proveedor TABOOLA). */
export const taboolaTemplate: ClaudeTemplate = {
  id: "taboola",
  tool: "Taboola Ads",
  url: "https://ads.taboola.com/",
  hierarchy: "Account → Campaign → Ads / items (imagen o vídeo + título + URL)",
  idHint: "ID de la campaña en el listado (columna ID) o en la URL al abrirla",
  accountField: "taboolaAccountIds",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre Taboola Ads ({{url}}). Si ya está abierto, sigue.
2. Elige la **Account** del cliente {{client}} en el selector de cuentas. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscala por nombre; si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, crea una nueva ("New campaign"):
   - Campaign name: {{names.order}}
   - Marketing objective: el que encaje con {{goal.kpi}} (CPC → Website traffic / Online purchases; CPM → Brand awareness; CPV → Video views; CPA/CPL → Leads o Conversions).
   - Schedule: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: {{goal.budget}} como presupuesto total de la campaña (spending limit), con entrega uniforme. Si solo deja diario, reparte el total entre los días y dímelo.
   - Bid strategy: CPC fijo (o el modelo que corresponda) en torno a {{goal.netUnitCost}}. Si la cuenta propone Smart Bid / Target CPA, pregunta antes.
3. Targeting:
   - Location: {{target.geography}} (país {{goal.country}}).
   - Platform: {{target.technology}}.
   - Audiencias / intereses: {{target.audience}} / {{target.interests}}.
   - Bloqueo de sites / exclusiones: {{target.exclusions}}.
4. Tracking: los parámetros UTM de la URL de destino (bloque "URLs de destino") van en el campo "Tracking code" si la herramienta lo separa de la URL.
5. Guarda la campaña **en pausa**.

### 3. Ads
1. Tipo de anuncio según el tipo de campaña {{campaignType}}: NATADS_COMERCIAL / NATADS_EDITORIAL → imagen + título; VIDEO_NATADS → vídeo; CARROUSEL → carrusel si la cuenta lo tiene disponible.
2. Para cada creatividad del bloque "Creatividades", crea un anuncio con su imagen o vídeo, el título y la descripción del bloque "Copies", el branding text {{brand}} y la URL de destino.
3. Si hay más imágenes que títulos (o al revés), combínalos como tenga sentido y dímelo.
4. Guarda sin activar. Los anuncios pasan por revisión de Taboola: es normal.
`,
};
